import { Injectable } from '@angular/core';
import {BehaviorSubject, ReplaySubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StoreService {
  public homeDepartments :any[]=[]; 
  public uInfo:any = null;
  public socialData = new Subject<any>();
  public languageChange = new Subject<any>();
  public loaderSubject = new BehaviorSubject<boolean>(false);
  public allServiceLists = new BehaviorSubject<any>([]);
  public allServiceReplay = new ReplaySubject<any>(1);
  public helpSupportInfoReplay = new ReplaySubject<any>(1);
  public whatsNewReplay = new ReplaySubject<any>(1);
  public helpSupportInfo = new BehaviorSubject<any>([]);
  public category = new ReplaySubject<any>(1);
  public socialInfo:any = null;
  public profileData:any = null;
  public apiGivingError = true;
  public settedLanguage = null; 
  private abc  : any ;
  public storeData = {};
  public redirectURL= null;
  public filteredResult = false;
  public isLocationEnable = false;
  public schemeFilterSubject = new BehaviorSubject<any>([]);
  public langCode = new Subject();
  public updateVisitCount = new BehaviorSubject(false);
  constructor() { }

  setProfileData(data: any){
    this.profileData = data;
  }

  getProfileData(){
    return this.profileData;
  }

  set helpSupport(data : any)  {
    this.abc = data;
  }

  get helpSupport()  {
    return this.abc;
  }
  get macAddress():string{
    let fma = "XXXX:XXXX:XXXX:XXXX:XXXX:XXXX:XXXX:XXXX".replace(/X/g, function() {
      return "0123456789abcdef".charAt(Math.floor(Math.random() * 16))
    })
    return fma.replace(/:/g, "")
  }

}
